import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { useReferrer } from '@plato/ui-legacy/lib/hooks/use-referrer';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useAiChatExplorerColumns } from '../../features/explorer/hooks/use-ai-chat-explorer-columns.ts';
import InventoryDetails from '../../features/inventory/components/inventory-details.tsx';
import { useOrderColumnsForProductDetail } from '../../features/list-views/columns/use-order-columns-for-product-detail.tsx';
import { useProductAvailibilityColumns } from '../../features/list-views/columns/use-product-availibility-columns.tsx';
import { useQuoteColumnsForProductDetail } from '../../features/list-views/columns/use-quote-columns-for-product-detail.tsx';

export function useProductDetailAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    const orderColumns = useOrderColumnsForProductDetail();
    const quoteColumns = useQuoteColumnsForProductDetail();
    const explorerColumns = useAiChatExplorerColumns();
    const availabilityColumns = useProductAvailibilityColumns();
    const columns = useMemo(
        () => [...orderColumns, ...quoteColumns, ...explorerColumns, ...availabilityColumns],
        [orderColumns, quoteColumns, explorerColumns, availabilityColumns],
    );

    return usePageAiMeta(
        {
            path: '/inventory/:product_id',
            title: t('page_title__product_details', { ns: 'common' }),
            description:
                "One product in full. The page heading is the product's name, reached by clicking a " +
                'product anywhere in Plato. Tabs for master data, description, related-product ' +
                'recommendations and variants, stock per storage location where the tenant has it, the ' +
                'orders and quotes that contain it where the tenant has them, and Sales Reports, the ' +
                'tenant-wide Sales Reports pivot scoped to this product. Send the user here for ' +
                'anything about a specific product. The product_id param is the ERP product id.',
        },
        columns,
    );
}

function NewQuoteLineItems() {
    const navigate = useNavigate();
    const params = useParams<{ product_id: string }>();
    const { isInternal: lastPathIsPlato } = useReferrer();

    const goBack = () => {
        if (lastPathIsPlato) {
            void navigate(-1);
        } else {
            void navigate('/');
        }
    };

    return <InventoryDetails erpProductId={params.product_id || ''} onBack={goBack} />;
}

export default NewQuoteLineItems;
